import formName from 'constants/formName'
import { actions, actionTypes, selectors } from 'data'
import { SubmitTierTwoActionType } from 'data/actions'
import { UserType } from 'data/Auth/types'
import { TierTwoFormType } from 'data/types'
import isNil from 'lodash/isNil'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { selectTier } from 'services/api/kyc'

import AppComplete from './appComplete'
import { goToStep } from './common'
import eddStep from './eddStep'
import finalStep from './finalStep'
import preIdvStep from './preIdvStep'
import ssnStep from './ssnStep'
import veriffStep, { syncVeriff } from './veriffStep'
import welcomeStep from './welcomeStep'

type Saga = (...args: any[]) => any

const steps: Record<string, Saga> = {
  appComplete: AppComplete,
  edd: eddStep,
  final: finalStep,
  preIdv: preIdvStep,
  ssn: ssnStep,
  veriff: veriffStep,
  welcome: welcomeStep
}

const getVerif = function* () {
  yield put(actions.form.change(formName.TIER_TWO, 'loading', false))
  yield call(selectTier, 2)
  const user: void | UserType = yield select(selectors.auth.getUser)

  if (
    !isNil(user) &&
    user &&
    user.address &&
    user.address.country === 'US' &&
    (isNil(user.ssnVerified) || user.ssnVerified === false)
  ) {
    yield call(goToStep, 'ssn')
  } else {
    yield call(goToStep, 'preIdv')
  }

  yield put(actions.app.showModal('TIER_TWO'))
}

const submitTierTwoStep = function* (action: SubmitTierTwoActionType) {
  const form: TierTwoFormType = yield select(selectors.tierTwo.getValuesOrInitial)
  yield call(steps[action.payload.step], form)
}

export const getEddStatus = function* () {
  const isHighRisk: boolean = yield select(selectors.auth.isHighRisk)

  if (isHighRisk) {
    yield put(actions.app.showModal('TIER_TWO'))

    yield call(goToStep, 'edd')
  }
}

export default function* TierTwoForm() {
  yield takeEvery(actionTypes.tierTwo.SUBMIT, submitTierTwoStep)
  yield takeEvery(actionTypes.tierTwo.SYNC_VERIFF, syncVeriff)
  yield takeEvery(actionTypes.tierTwo.GET_VERIF, getVerif)
  yield takeEvery(actionTypes.auth.AUTHED, getEddStatus)
}
